import * as API from '@/services/API';

export default {
  async createItineraryItemFromTemplate(data) {
    return API.apiClient.post(`/itinerary-item/create-from-template`, data);
  },
  async copyItineraryItemsFromSubgroup(data) {
    return API.apiClient.post(`/itinerary-item/copy`, data);
  },
  async generateWeekendsForSubgroup(data) {
    return API.apiClient.post(`/itinerary-item/weekends`, data);
  },
  get(id) {
    return API.apiClient.get(`/itinerary-item/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/itinerary-item/${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/itinerary-item/`, data);
    } else {
      return API.apiClient.put(`/itinerary-item/${id}`, data);
    }
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async delete(id) {
    return API.apiClient.delete(`/itinerary-item/${id}`);
  }
};
